import { createSlice } from "@reduxjs/toolkit"

const slice = createSlice({
    name: 'scanner',
    initialState: {
        open: false,
        type: 'camera', // camera, hid - сканер
        activate: false, //  Якщо вже активований сканер, але ще не відкритий. Треба для того, щоб не можливо було відкрити сканер в різних компонентах
        cameraId: null, // Якщо треба буде обирати конкретну камеру
        result: '',
    },
    reducers: {
        setScannerOpen(state, action) {
            state.open = action.payload
        },
        setScannerType(state, action) {
            state.type = action.payload
        },
        setScannerActivate(state, action) {
            state.activate = action.payload
        },
        setScannerCameraId(state, action) {
            state.cameraId = action.payload
        },
        setScannerResult(state, action) {
            state.result = action.payload
        },
    }
})

export default slice.reducer

export const {
    setScannerOpen,
    setScannerType,
    setScannerActivate,
    setScannerCameraId,
    setScannerResult,
} = slice.actions